export const ORDER_CURRENCIES = ['USD', 'EUR', 'PLN'] as const;

export type OrderCurrency = typeof ORDER_CURRENCIES[number];
